function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { USD, CAD, AUD, GBP } from "../constants/consts";
export { formatCurrency } from '@applyboard/ui-utils';

//export { default as currencyObjectSelector } from './currencyObjectSelector';

export var currencyObjectSelector = function currencyObjectSelector(currencies, curCurrencyCode) {
  var result = {
    name: 'unpublished currency',
    sign: '?',
    code: curCurrencyCode,
    prefix: true
  };
  if (!Array.isArray(currencies)) {
    throw new TypeError('currencyObjectSelector: currencies must be an array');
  }
  var _iterator = _createForOfIteratorHelper(currencies),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var c = _step.value;
      if (c.code === curCurrencyCode) {
        result = c;
        break;
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return result;
};
export var currencySelector = function currencySelector(currency) {
  if (!currency || typeof currency !== 'string') return currency;
  switch (currency.toLowerCase()) {
    case 'cad':
    case 'ca':
    case 'canada':
      return CAD;
    case 'usd':
    case 'usa':
      return USD;
    case 'uk':
    case 'gbp':
    case 'united kingdom':
      return GBP;
    case 'au':
    case 'aud':
    case 'australia':
      return AUD;
  }
  return currency;
};

/* Return the Currency Object for a country given list of countries and currencyCode */
export var countryObjectSelector = function countryObjectSelector(countries, curCurrencyCode) {
  var result = countries.find(function (country) {
    return country.currency.code === curCurrencyCode;
  });
  return result || 'N/A';
};